import React from 'react';
import {Provider} from "components/citizen-otp/CitizenOTPContext";
import {CitizenOTPList} from "components/citizen-otp/CitizenOTPList";

export const CitizenOTPs = () => {

    return (
        <Provider>
            <CitizenOTPList/>
        </Provider>
    );
}
